import { X } from "react-feather";
import styles from "./SelectionBar.module.scss";

const SelectionType = {
  company: "Company",
  logistics: "Logistic",
  tradeLanes: "Trade Lane",
  shipments: "Shipment",
  ports: "Port",
  contact: "Contact",
};

const PluralSelectionType = {
  company: "Companies",
  logistics: "Logistics Companies",
  tradeLanes: "Trade Lanes",
  shipments: "Shipments",
  ports: "Ports",
  contact: "Contacts",
};

export const SelectionBarTemplete = ({ options, clearSelection, selectedCompanyArray, type }) => {
  return (
    <div className={styles.selectionBarContainer}>
      <div className="mr-3">
        <span className={styles.selectionPill}>{selectedCompanyArray.length}</span>
        <span className="ml-2">{selectedCompanyArray.length > 1 ? (PluralSelectionType?.[type] ?? "Companies") : (SelectionType?.[type] ?? "Company")} Selected</span>
      </div>
      {options &&
        options?.length &&
        options.map(
          ({ icon, name, cb, omit }) =>
            !omit && (
              <div onClick={cb} key={name} className="d-flex mr-3 cursor-pointer align-items-center">
                {icon && <img className="mr-2" src={icon} width={18} height={18} alt="name" />}
                <p className="m-0">{name}</p>
              </div>
            )
        )}
      <span onClick={clearSelection} className={styles.clearSelection}>
        <X size={18} />
      </span>
    </div>
  );
};
